import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { finalize, map } from 'rxjs';
import { ClientWarranty } from 'src/app/pages/dashboards/files-clients/interface/company-client.interface';
import { ServiceInfoClientService } from 'src/app/pages/dashboards/files-clients/service/service-info-client.service';
import { AddOrRemoveWarrantiesMinuteRequestDTO, AddWarrantiesToMinuteViewModel } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/interface/minute-request.interface';
import { MinuteRequestService } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/service/minute-request.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-warranties-to-minute-modal',
  templateUrl: './add-warranties-to-minute-modal.component.html',
  styleUrls: ['./add-warranties-to-minute-modal.component.scss']
})
export class AddWarrantiesToMinuteModalComponent implements OnInit{
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public dataSource: MatTableDataSource<ClientWarranty>;
  public selection = new SelectionModel<ClientWarranty>(true, [], false, (io1, io2) => io1.warrantyId === io2.warrantyId);
  public loading: boolean = false;

  public displayCols  = [
    'selectionColumn',
    'warrantyType',
    'insuranceCompany',
    'createdAt',
    'tender',
    'amount',
    'amountType',
    'cost',
    'nameTenderBuyer',
    'requestDate',
    'endDate',
    'tasa',
    'insuranceBroker',
    'isForBuilding',
    'contractAmount'
  ];


  constructor(private dialogRef: MatDialogRef<AddWarrantiesToMinuteModalComponent>,
    private serviceClient: ServiceInfoClientService,
    private minuteRequestService: MinuteRequestService,
    @Inject(MAT_DIALOG_DATA)public data: AddWarrantiesToMinuteViewModel
  ){
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnInit(): void {
    this.getPendingWarranties();
  }

  public getPendingWarranties() {
    this.loading = true;
    this.serviceClient.getCompanyPendingApproveWarranties(this.data.companyId, '')
    .pipe(
      map((data) => data.filter(w => !this.data.addedWarrantiesId.includes(w.warrantyId))),
      finalize(() => this.loading = false)
    )
    .subscribe({
      next:(res) => {
        this.setDataSource(res);
      }
    })
  }

  private setDataSource(warranties: ClientWarranty[]) {
    this.dataSource.data = warranties;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public addWarranties() {
    const warrantiesId = this.selection.selected.map(w => w.warrantyId);
    const request: AddOrRemoveWarrantiesMinuteRequestDTO = {
      minuteRequestId: this.data.minuteRequestId,
      warrantiesId: warrantiesId
    };
    Swal.fire({
      title: 'Agregando a la minuta',
      didOpen: () => {
        Swal.showLoading();
        this.minuteRequestService.addWarrantiesToMinute(request)
        .subscribe({
          next: (res) => {
            this.showMessage(res.resultMessage, 'Success');
          },
          error: (err) => { 
            this.showMessage(err.error.resultMessage || 'Ha ocurrido un error', 'Error');
          }
        });    
      }
    })

  }

  public closeDialog() {
    this.dialogRef.close();
  }


  private showMessage(resultMessage: string, status: 'Success' | 'Error') {
    if(status === 'Success'){
      Swal.fire({
        icon: 'success',
        title: resultMessage,
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((r) => {
        if(r.isConfirmed) {
          this.closeDialog();
        }
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: resultMessage
      });
    }
  }

}
